import React, { Component } from "react";
import { Layout, Row, Col, Button, List, Space, Typography, Card, message, Popconfirm, PageHeader } from "antd";
import { FileSearchOutlined, EditOutlined, DeleteOutlined, FilterOutlined, PlusOutlined, MinusOutlined, SwapOutlined, StopOutlined } from "@ant-design/icons";

import Logged from '../../../../../Hooks/Logged';
import usePermissions from '../../../../../Hooks/usePermissions';

import DrawerFiltros from '../../../../Widgets/DrawerFiltros/DrawerFiltros';
import Sort from '../../../../Widgets/Sort';
import CustomAvatar from '../../../../Widgets/Avatar/Avatar';

import ModalTransaccion from '../../../Finanzas/Transacciones/ModalTransaccion';
import ModalTransaccionDetalle from '../../../Finanzas/Transacciones/ModalTransaccionDetalle';
import ActionsDropdown from "../../../../Widgets/Actions/ActionsDropdown";

import axios from 'axios';
import moment from 'moment-timezone';

const { Content } = Layout;
const { Text } = Typography;

class TransaccionesClienteTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transacciones: {
        data: [],
        page: 1,
        limit: 20,
        total: 0,
        pages: 0,
        search: undefined,
        filters: [],
        sort: { fecha: -1 },
      },
      loading: false,

      modalTransacVisible: false,
      modalTransacDetalleVisible: false,
      transaccion_id: undefined,

      visibleFilters: false,
    };
  }

  componentDidMount() {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
    this.getTransacciones();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.search !== prevProps.search ||
      this.props.cliente_id !== prevProps.cliente_id
    ) {
      this.getTransacciones({ page: 1, search: this.props.search });
    }
  }

  getTransacciones = ({
    page = this.state.transacciones.page,
    limit = this.state.transacciones.limit,
    search = this.state.transacciones.search,
    filters = this.state.transacciones.filters,
    sort = this.state.transacciones.sort,
  } = this.state.transacciones) => {
    this.setState({
      transacciones: { ...this.state.transacciones, page, limit, search, filters, sort },
      loading: true
    });

    axios.post('/transacciones/filters', {
      page,
      limit,
      filters,
      sort,
      search,
      cliente_id: this.props.cliente_id,
    })
      .then(({ data }) => {
        const rows = data?.data ?? [];
        const total = data?.total ?? rows.length;
        const pages = data?.pages && data.pages > 0 ? data.pages : Math.ceil((total || 1) / (limit || 1));
        this.setState(s => ({
          transacciones: {
            ...s.transacciones,
            data: rows,
            total,
            pages,
            page,
            limit,
          },
          loading: false
        }));
      })
      .catch(() => message.error('No se pudieron cargar las transacciones'))
      .finally(() => this.setState({ loading: false }));
  }

  setSort = (key) => {
    let value;
    switch (this.state.transacciones.sort?.[key]) {
      case 1: value = -1; break;
      case -1: value = undefined; break;
      default: value = 1; break;
    }
    this.getTransacciones({ sort: { [key]: value } });
    this.setState(s => ({ transacciones: { ...s.transacciones, sort: { [key]: value } } }));
  }

  renderIconTransaccion = (tipo) => {
    switch (tipo) {
      case 1: return <PlusOutlined style={{ color: "currentColor" }} />;
      case 2: return <MinusOutlined style={{ color: "currentColor" }} />;
      case 3: return <SwapOutlined style={{ color: "currentColor" }} />;
      case 4: return <StopOutlined style={{ color: "currentColor" }} />;
      default: return null;
    }
  }

  colorTipo = (tipo) => {
    switch (tipo) {
      case 1: return "#21a121"; 
      case 2: return "#d32029"; 
      case 3: return "#8c8c8c"; 
      case 4: return "#fa8c16"; 
      default: return "currentColor";
    }
  }

  render() {
    const { transacciones, loading } = this.state;
    const pageLimit = (transacciones.page * transacciones.limit) - transacciones.limit;

    return (
      <>
        <PageHeader
          className='custom-page-header custom-transacciones-header-cliente'
          style={{ backgroundColor: "transparent" }}
          title={null} 
          extra={
            <Space>
              <Text style={{ color: "black"}}>
                Visualizando de {(pageLimit > 0) ? pageLimit : 1} a {(transacciones.page * transacciones.limit)} de {transacciones.total?.toLocaleString()} transacciones
              </Text>
              <Button
                type="dashed"
                onClick={() => this.setState({ visibleFilters: true })}
                className="button-plus"
                icon={<FilterOutlined />}
              />
            </Space>
          }
        />

        <Content className="admin-content content-bg pd-1">
          <List
            loading={loading}
            className="component-list"
            itemLayout="horizontal"
            locale={{ emptyText: "Sin Transacciones" }}
            dataSource={transacciones?.data}
            pagination={{
              current: transacciones.page,
              pageSize: transacciones.limit,
              total: transacciones.total,
              position: 'bottom',
              className: "flex-left",
              showSizeChanger: true,
              pageSizeOptions: [20, 50, 100, 500],
              showQuickJumper: true,
              locale: { jump_to: "Ir a la página", page: '' },
              onChange: (page, limit) => this.getTransacciones({ page, limit })
            }}
            header={
              <Row className="header-list width-100">
                <Col xs={3} className="center">
                  <Sort sort={transacciones?.sort?.["fecha"]} onClick={() => this.setSort("fecha")}>
                    <Text strong>FECHA</Text>
                  </Sort>
                </Col>
                <Col xs={4} className="center">
                  <Sort sort={transacciones?.sort?.["concepto"]} onClick={() => this.setSort("concepto")}>
                    <Text strong>CONCEPTO</Text>
                  </Sort>
                </Col>
                <Col xs={4} className="center">
                  <Sort sort={transacciones?.sort?.["area_id.nombre"]} onClick={() => this.setSort("area_id.nombre")}>
                    <Text strong>ÁREA</Text>
                  </Sort>
                </Col>
                <Col xs={4} className="center">
                  <Sort sort={transacciones?.sort?.["rubro_id.nombre"]} onClick={() => this.setSort("rubro_id.nombre")}>
                    <Text strong>RUBRO</Text>
                  </Sort>
                </Col>
                <Col xs={4} className="center">
                  <Sort sort={transacciones?.sort?.["cuenta_id.nombre"]} onClick={() => this.setSort("cuenta_id.nombre")}>
                    <Text strong>CUENTA</Text>
                  </Sort>
                </Col>
                <Col xs={3} className="center">
                  <Sort sort={transacciones?.sort?.["monto"]} onClick={() => this.setSort("monto")}>
                    <Text strong>MONTO</Text>
                  </Sort>
                </Col>
                <Col xs={2} className="center">
                
                </Col>
              </Row>
            }

            renderItem={(item) => (
              <List.Item className="component-list-item ">
                <Card className="card-list" bordered={false}>
                  <div className={`badge-card tipo-${item.tipo}`} />
                  <Row className="width-100" align="middle">
                    <Col xs={3} className="center">
                      <Text strong>{moment.tz(item.fecha, "America/Mexico_City").format('YYYY-MM-DD')}</Text>
                    </Col>

                    <Col xs={4} className="flex-column">
                      <Text ellipsis className="text-gray-dark">{item.concepto}</Text>
                      <Text ellipsis style={{ fontSize: 12 }}>{item.uuid ? item.uuid : null}</Text>
                    </Col>

                    <Col xs={4} className="center">
                      <Text ellipsis className="text-gray-dark">{item.area_id?.nombre}</Text>
                    </Col>

                    <Col xs={4} className="center">
                      <Text ellipsis className="text-gray-dark">{item.rubro_id?.nombre}</Text>
                    </Col>

                    <Col xs={4} className="center">
                      {item?.cuenta_id && (
                        <>
                          <CustomAvatar
                            image={axios.defaults.baseURL + '/upload/' + item?.cuenta_id?.logo}
                            color={item.cuenta_id?.color}
                            name={item.cuenta_id?.nombre}
                          />
                          <Text className="text-gray-dark">{item.cuenta_id?.nombre}</Text>
                        </>
                      )}
                    </Col>

                    <Col xs={3} className="center">
                      <Text style={{ color: this.colorTipo(item.tipo), fontWeight: "bold" }}>
                        {this.renderIconTransaccion(item.tipo)} $ {item.monto.toMoney(true)} MXN
                      </Text>
                    </Col>

                    <Col xs={2} className="center">
                      <ActionsDropdown
                          onView={() =>
                              this.setState({
                                  modalTransacDetalleVisible: true,
                                  transaccion_id: item._id,
                              })
                          }
                          onEdit={() =>
                              this.setState({
                                  modalTransacVisible: true,
                                  transaccion_id: item._id,
                              })
                          }
                          onDelete={() =>
                          axios
                              .delete('/transacciones', { params: { id: item._id } })
                              .then(() => {
                                  message.success('Transacción Eliminada');
                                  this.getTransacciones();
                              })
                              .catch(() => {
                                  message.error('Transacción No Eliminada');
                                  this.getTransacciones();
                              })
                          }
                          
                      />
                      {/*<Space size="small" wrap={false}>
                      
                        <Button
                          size="small"
                          icon={<FileSearchOutlined style={{ color: "currentcolor" }} />}
                          type="secondary"
                          title="Ver Detalle"
                          onClick={() => this.setState({ modalTransacDetalleVisible: true, transaccion_id: item._id })}
                        />

                      
                        <Button
                          size="small"
                          className="ant-btn-primary-blue"
                          disabled={!this.props.editTransacciones}
                          icon={<EditOutlined style={{ color: "currentcolor" }} />}
                          type="primary"
                          title="Editar"
                          onClick={() => this.setState({ modalTransacVisible: true, transaccion_id: item._id })}
                        />

                    
                        <Popconfirm
                          disabled={!this.props.deleteTransacciones}
                          placement="topRight"
                          title="¿Deseas eliminar esta Transacción?"
                          onConfirm={() =>
                            axios.delete('/transacciones', { params: { id: item._id } })
                              .then(() => { message.success('Transacción Eliminada'); this.getTransacciones(); })
                              .catch(() => { message.error('Transacción NO Eliminada'); this.getTransacciones(); })
                          }
                          okText="Si"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            className="ant-btn-primary-red"
                            type="primary"
                            icon={<DeleteOutlined style={{ color: "currentcolor" }} />}
                            title="Eliminar"
                            disabled={!this.props.deleteTransacciones}
                          />
                        </Popconfirm>
                      </Space>*/}
                    </Col>
                  </Row>
                </Card>
              </List.Item>
            )}
          />
        </Content>

        <ModalTransaccion
          visible={this.state.modalTransacVisible}
          transaccion_id={this.state.transaccion_id}
          onClose={() => {
            this.setState({ modalTransacVisible: false, transaccion_id: undefined });
            this.getTransacciones();
          }}
        />
        <ModalTransaccionDetalle
          visible={this.state.modalTransacDetalleVisible}
          onClose={() => this.setState({ modalTransacDetalleVisible: false, transaccion_id: null })}
          transaccion_id={this.state.transaccion_id}
        />

        <DrawerFiltros
          title="Filtrar Transacciones"
          ref={ref => this.drawerFiltros = ref}
          updateFilters={filters => this.getTransacciones({ page: 1, filters })}
          onClose={() => this.setState({ visibleFilters: false })}
          visible={this.state.visibleFilters}
          proveedores={true}
          accreedores={true}
          acreedores={true}
          inversiones={true}
          ordenes={false}
          ordenes_compras={false}
        />
      </>
    );
  }
}

export default function (props) {
  const user = React.useContext(Logged);

  const permissions = usePermissions(user?.rol_id?.permisos, {
    editTransacciones: ["transacciones", "edit"],
    deleteTransacciones: ["transacciones", "delete"],
    readTransacciones: ["transacciones", "read"],
  });

  return (
    <TransaccionesClienteTab
      {...props}
      {...permissions}
    />
  );
}
